import React from "react";
import Template1 from "pages/createform/Template1";
import Template2 from "pages/createform/Template2";
import CustomTab from "components/Tab";
import CustomForm from "./CustomForm";
import { useTranslation } from "react-i18next";

function CreateForm({ closeModal, handleSelectTemplate, jobDetail, handleTabChange, tabValue }) {
  const { t } = useTranslation();
  const Tablist = [
    {
      label: t('Job.Template1'),
      content: <Template1 handleSelectTemplate={() => handleSelectTemplate("Template 1")} closeModal={closeModal} />,
    },
    {
      label: t('Job.Template2'),
      content: <Template2 handleSelectTemplate={() => handleSelectTemplate("Template 2")} closeModal={closeModal} />,
    },
    {
      label: t('Job.CustomTemplate'),
      content: <CustomForm handleSelectTemplate={(element) => handleSelectTemplate("Custom Template", element)} closeModal={closeModal} jobDetail={jobDetail} />,
    },
  ];
  return <CustomTab defaultTabValue={tabValue} tabList={Tablist} handleTabChange={handleTabChange} />;
}

export default CreateForm;
